import { HelperInputDefinition } from '../../../../types';

// helper input validation
export default (input: HelperInputDefinition, errors: string[]) => {
  const { content } = input;
  if (!content) {
    errors.push('No helper content defined');
  }
};
